import { updateBenefitModel } from "../../../infrastructure/employees-cache";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import renderBenefitPlanPage from "../../../infrastructure/renders/BenefitPlanPage/render-benefit-plan-page";
import { displayBenefitPage } from "../../benefit-model/displays/display-benefit-page";

export default async function addEmployeesToBenefitPlan({ benefitPlan }) {
  renderBenefitPlanPage({ isLoading: true, benefitPlan });
  const companyId = await findCompanyId();
  await updateBenefitModel({
    companyId,
    employeeIds: benefitPlan.employees.map(({ id }) => id),
    modelId: benefitPlan.id,
  });
  displayBenefitPage();
}
